import React from 'react'

export const GuideProvidePage = React.lazy(() => import('../components/guideProvidePage'))
export const ProvideProfilePage = React.lazy(() => import('../components/provideProfilePage'))
export const VerifyProfilePage = React.lazy(() => import('../components/verifyProfilePage'))
